import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=71f7c1a0&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=71f7c1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7c1a0",
  null
  
)

export default component.exports